webpackJsonp([113774609660216],{

/***/ 1209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _difference = __webpack_require__(291);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _without = __webpack_require__(299);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _messageBlock = __webpack_require__(65);
	
	var _messageBlock2 = _interopRequireDefault(_messageBlock);
	
	var _FormWrap = __webpack_require__(202);
	
	var _FormWrap2 = _interopRequireDefault(_FormWrap);
	
	var _forms = __webpack_require__(49);
	
	var _api = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = [{
	  errorMsg: 'Provided company name must be one word!',
	  label: 'Enterprise domain',
	  name: 'company',
	  placeholder: 'your-company-domain'
	}];
	
	var inputFieldNames = fields.map(function (field) {
	  return field.name;
	});
	
	var SSOForm = function (_Component) {
	  _inherits(SSOForm, _Component);
	
	  function SSOForm(props) {
	    _classCallCheck(this, SSOForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setFieldValue = function (e, fieldName) {
	      var value = e.target.value;
	      var validFields = [];
	
	      if (_this.state.validFields.indexOf(fieldName) !== -1) {
	        var _this$setState;
	
	        validFields = (0, _without2.default)(validFields, fieldName);
	        _this.setState((_this$setState = {}, _this$setState[fieldName] = value, _this$setState.validFields = validFields, _this$setState));
	      } else {
	        var _this$setState2;
	
	        _this.setState((_this$setState2 = {}, _this$setState2[fieldName] = value, _this$setState2));
	      }
	    };
	
	    _this.validateForm = function (e) {
	      e.preventDefault();
	      if (_this.isFormValid()) {
	        _this.logIn();
	      }
	    };
	
	    _this.isFormValid = function () {
	      var company = _this.state.company;
	
	      var invalidFields = [];
	
	      if (!(0, _forms.isCompanyNameValid)(company) || company === '') {
	        invalidFields.push('company');
	      }
	
	      var validFields = (0, _difference2.default)(inputFieldNames, invalidFields);
	
	      _this.setState({
	        invalidFields: invalidFields,
	        backendErrorMsg: '',
	        validFields: validFields
	      });
	
	      return !invalidFields.length;
	    };
	
	    _this.logIn = function () {
	      var company = _this.state.company;
	
	      _this.setState({ isPending: true });
	      if (typeof window !== 'undefined') {
	        window.location.href = 'https://' + company + '.marvelapp.com/sso/auth/?next=' + _this.props.redirectTo;
	      }
	    };
	
	    _this.state = {
	      company: '',
	      invalidFields: [],
	      isPending: false,
	      backendErrorMsg: '',
	      validFields: []
	    };
	    if (_this.props.cname) {
	      _this.state.company = _this.props.cname;
	      fields = [];
	    }
	    return _this;
	  }
	
	  SSOForm.prototype.render = function render() {
	    var _state = this.state,
	        invalidFields = _state.invalidFields,
	        isPending = _state.isPending,
	        validFields = _state.validFields,
	        backendErrorMsg = _state.backendErrorMsg;
	
	
	    var buttonProps = {
	      text: 'Sign in',
	      color: 'green'
	    };
	
	    return _react2.default.createElement(
	      _FormWrap2.default,
	      {
	        backendErrorMsg: backendErrorMsg,
	        buttonProps: buttonProps,
	        fields: fields,
	        invalidFields: invalidFields,
	        isPending: isPending,
	        setFieldValue: this.setFieldValue,
	        validateForm: this.validateForm,
	        validFields: validFields,
	        isSSOSignIn: true,
	        autocomplete: 'on',
	        redirectTo: this.props.redirectTo,
	        action: _api.API_LOGIN,
	        messaging: this.props.messaging
	      },
	      _react2.default.createElement(
	        _messageBlock2.default,
	        { type: 'error', fullWidth: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'fontSize-m' },
	          backendErrorMsg
	        )
	      )
	    );
	  };
	
	  return SSOForm;
	}(_react.Component);
	
	exports.default = SSOForm;
	
	
	SSOForm.propTypes = {
	  cname: _propTypes2.default.string,
	  redirectTo: _propTypes2.default.string,
	  messaging: _propTypes2.default.object
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = SSO;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _forms = __webpack_require__(49);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _AccountPagesWrap = __webpack_require__(146);
	
	var _AccountPagesWrap2 = _interopRequireDefault(_AccountPagesWrap);
	
	var _SSOForm = __webpack_require__(1209);
	
	var _SSOForm2 = _interopRequireDefault(_SSOForm);
	
	var _urls = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SSO(_ref) {
	  var history = _ref.history;
	
	  var pageProps = {
	    title: 'SSO | Marvel',
	    meta: [{
	      name: 'description',
	      content: 'Sign in to your secure Marvel SSO account and access all of our great features.'
	    }, { name: 'keywords', content: '' }],
	    header: false
	  };
	
	  var cname = (0, _forms.getCnameForUrl)();
	  var redirectTo = (0, _forms.getNextRedirectParam)();
	  var signinLinkWithRedirect = (0, _forms.getUrlWithRedirect)(_urls.SIGNIN);
	
	  var messaging = {
	    header: _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'm', position: 'bottom' },
	      _react2.default.createElement(
	        _heading2.default,
	        { tag: 'h1', size: 'xxxl', weight: 'bold' },
	        'Enterprise Platform SSO sign in'
	      )
	    ),
	    copy: _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'l', position: 'bottom' },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'l', color: 'slate' },
	        'If you don\u2019t know your company name, speak to your account admin.'
	      )
	    )
	  };
	
	  if (cname) {
	    messaging = {
	      header: _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', size: 'xs', position: 'bottom' },
	        _react2.default.createElement(
	          _heading2.default,
	          { tag: 'h1', size: 'xxxl', weight: 'bold' },
	          'Enterprise Platform SSO sign in'
	        )
	      ),
	      copy: _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', sizeМ: 'm', position: 'bottom' },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'l', color: 'slate' },
	          'Click the button below to access Marvel using your Single Sign-On provider.'
	        )
	      )
	    };
	  }
	
	  return _react2.default.createElement(
	    _Page2.default,
	    pageProps,
	    _react2.default.createElement(
	      _AccountPagesWrap2.default,
	      { history: history },
	      _react2.default.createElement(_SSOForm2.default, { redirectTo: redirectTo, cname: cname, messaging: messaging }),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', size: 'm', sizeM: '0', position: 'top' },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'slate' },
	          'Switch to standard',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: signinLinkWithRedirect },
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue' },
	              'sign in'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	SSO.propTypes = {
	  history: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sso-index-js-acf1839897a557107189.js